import Swal from 'sweetalert2';

function escapeHtml(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

const base = {
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3200,
  timerProgressBar: true,
  background: '#ffffff',
  color: '#0a118a',
  customClass: {
    popup: 'rounded-xl border border-slate-200 shadow-premium',
  },
};

export function toastSuccess(title, text) {
  return Swal.fire({
    ...base,
    icon: 'success',
    title,
    text,
  });
}

export function toastError(title, text) {
  return Swal.fire({
    ...base,
    icon: 'error',
    title,
    text,
  });
}

export function toastWarning(title, text) {
  const t = title != null ? String(title).trim() : '';
  const x = text != null ? String(text).trim() : '';

  if (t && x) {
    return Swal.fire({
      ...base,
      icon: 'warning',
      html: `<div style="text-align:left"><p style="margin:0;font-weight:700;font-size:1rem;line-height:1.35">${escapeHtml(t)}</p><p style="margin:0.5em 0 0;font-size:0.875rem;font-weight:500;line-height:1.4;opacity:0.95">${escapeHtml(x)}</p></div>`,
      timer: 5500,
    });
  }

  if (t) {
    return Swal.fire({
      ...base,
      icon: 'warning',
      title: t,
      timer: 5200,
    });
  }

  return Swal.fire({
    ...base,
    icon: 'warning',
    title: 'Aviso',
    ...(x
      ? {
          html: `<p style="margin:0.35em 0 0;font-size:0.9rem;font-weight:500;line-height:1.35">${escapeHtml(x)}</p>`,
          timer: 5200,
        }
      : {}),
  });
}

export async function confirmDelete(title = '¿Eliminar?', text = 'Esta acción no se puede deshacer.') {
  const res = await Swal.fire({
    title,
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
    background: '#ffffff',
    color: '#0a118a',
    confirmButtonColor: '#15803b',
    cancelButtonColor: '#64748b',
  });
  return res.isConfirmed;
}
